import { Empty, Pagination } from "antd";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useSearchParams, Link } from "react-router-dom";
import { selectToken } from "../app/features/authen";
import { images } from "../assets";
import Agency from "../components/Agency";
import SImage from "../components/SImage";
import APIService from "../services/APIService";
export default function AgencyPage() {
  const [banner, setBanner] = useState({
    banners: [],
    qc_bottom: [],
    qc_middle: [],
  });
  const [totalPage, setTotalPage] = useState(0);
  const [searchParams, setSearchParams] = useSearchParams();
  const searchString = searchParams.get("search");
  const [loading, setLoading] = useState([]);
  const [page, setPage] = useState(1);
  const token = useSelector(selectToken);
  async function getListBanner() {
    const RESULT = await APIService.getListBanner("agency");
    if (RESULT) {
      console.log(RESULT);
      setBanner(RESULT);
    }
  }
  const [agentList, setAgentList] = useState([]);
  async function getAgentsList() {
    const RESULT = await APIService.getAgentsList(searchString, page, 10);
    if (RESULT) {
      setAgentList(RESULT.data);
      setTotalPage(RESULT.total);
    }
    setLoading(false);
  }
  useEffect(() => {
    setLoading(true);
    getAgentsList(page);
  }, [page, searchString]);
  useEffect(() => {
    getListBanner();
  }, []);
  const onChange = (page) => {
    setPage(page);
    console.log(page);
  };

  return (
    <div className="w-full">
      <div className="sm:h-[300px] h-[80px] rounded-xl mb-5 overflow-hidden">
        <img
          src={banner.banners[0]?.url}
          className="object-cover w-full h-full"
          alt=""
        />
      </div>
      <div className="flex flex-row">
        <div className="md:flex hidden flex-col gap-y-[20px] h-[500px] p-3 w-[247px] bg-[#FFFFFF] shadow-lg rounded-xl mr-6">
          {banner.qc_middle?.map((item, index) => (
            <SImage
              key="index"
              src={item.url}
              className="object-cover w-full h-full"
              alt=""
            />
          ))}
        </div>
        <div className="w-full">
          {searchString && (
            <h2 className="font-bold text-[#222222] sm:text-xl text-base	 not-italic mb-5">
              Kết quả tìm kiếm Đại lý cho: {searchString}
            </h2>
          )}

          {loading ? (
            <div className="flex justify-center w-full my-10">
              <div class="dots-indicators"></div>
            </div>
          ) : (
            <>
              <div className="grid sm:grid-cols-2 grid-cols-1  w-full gap-[10px] ">
                {agentList.map((item, index) => (
                  <Agency key={index} data={item}></Agency>
                ))}
              </div>
              {agentList?.length == 0 ? (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  imageStyle={{
                    height: 35,
                  }}
                  description={<span>Không tìm thấy Đại lý nào.</span>}
                ></Empty>
              ) : (
                <Pagination
                  pageSize={10}
                  current={page}
                  onChange={onChange}
                  total={totalPage}
                  showSizeChanger={false}
                  className="mt-6"
                />
              )}
            </>
          )}
        </div>
      </div>
      {!token ? (
        <div className="flex w-full h-[178px] rounded-2xl bg-white overflow-hidden shadow-lg mt-4">
          <img
            src={banner.qc_bottom[0]?.url}
            className="w-full h-full object-cover"
            alt=""
          />
          <div className="flex flex-col items-center justify-center w-[600px] gap-y-3">
            <span className="text-[#222222] not-italic text-xs sm:text-base font-normal  uppercase text-center ">
              Bạn muốn cửa hàng của bạn có mặt trên <strong>sPhACY?</strong>
            </span>
            <Link to="/signup">
              <button className="w-[155px] h-[38px] p-2 rounded-[30px] bg-[#7F4CEB]">
                <span className="text-base font-extrabold text-[#FFFFFF] not-italic capitalize ">
                  Tham Gia
                </span>
              </button>
            </Link>
          </div>
        </div>
      ) : null}
    </div>
  );
}
